import { trimNumber } from './trimNumber';

/**
 * Valida si el string es un numero que se pueda transorfmar de string a tipo "number" en javascript.
 * Controla en especial los numeros demasiado grandes.
 *
 * ¡IMPORTANTE! No puede aceptar un tipo "number" ya que entonces estaría ya corrupto antes de validarlo.
 *
 * Aqui una lista de maximos mas o menos, segun decimales
 * Number.MAX_SAFE_INTEGER, => 9007199254740991
 * 562949953421311,0
 * 70368744177663,00
 * 8796093022207,000
 * 549755813887,0000
 * 68719476735,00000
 * 8589934591,000000
 * 536870911,0000000
 * 67108863,00000000
 * 8388607,000000000
 * 524287,0000000000
 * 65535,00000000000
 *
 * Nota que isSafeNumber('') === false (ya que parseFloat('') ==> NaN)
 *
 * @param {string} str el numero a validar en string.
 * @returns {boolean}
 */
export function isSafeNumber(str) {
  if (typeof str !== 'string' || str === 'NaN') {
    return false;
  }
  // miramos que despues de la conversión en float,
  // tenemos exactamente el mismo numero
  const parsed = parseFloat(str);
  return !isNaN(parsed) && `${parsed}` === trimNumber(str);
}
